import { callGet, callPost } from "../../services/axios"
import { ACCESS_TOKEN_FAILED, ACCESS_TOKEN_START, ACCESS_TOKEN_SUCCESS, AUTH_EMAIL_FAILED, AUTH_EMAIL_START, AUTH_EMAIL_SUCCESS, DELETE_EMAIL_FAILED, DELETE_EMAIL_START, DELETE_EMAIL_SUCCESS, USER_EMAIL_FAILED, USER_EMAIL_START, USER_EMAIL_SUCCESS } from "../actionTypes/settings"

export const addEmailSignature = ({ notes, registeredEmailId }) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/emailSettings/addEmailSignature`, {
		notes,
		registeredEmailId
	}, token).then(async (res) => {
		return Promise.resolve(res['data'])
	}).catch(err => {
		return Promise.reject(err)
	})
}

export const getSavedEmailsAndSettingData = (userId) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callGet(`/api/emailSettings/getSavedEmailsAndSettingData/${userId}`, token).then(async (res) => {
		return Promise.resolve(res['data'])
	}).catch(err => {
		return Promise.reject(err)
	})
}

export const deleteEmailStart = () => {
	return { type: DELETE_EMAIL_START }
}
export const deleteEmailSuccess = (data) => {
	return { type: DELETE_EMAIL_SUCCESS, data: data }
}
export const deleteEmailFailed = () => {
	return { type: DELETE_EMAIL_FAILED }
}


export const deleteEmail = (emailId, emailIdToBeDefault) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	deleteEmailStart()
	return callPost(`/api/emailSettings/deleteEmail`, {
		emailId,
		emailIdToBeDefault
	}, token).then(async (res) => {
		deleteEmailSuccess(emailId)
		return Promise.resolve(res)
	}).catch(err => {
		deleteEmailFailed()
		return Promise.reject(err)
	})
}

export const sendEmail = (email, plainText, user) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/emailSettings/sendEmail`, {
		email,
		plainText,
		user
	}, token).then(async (res) => {
		return Promise.resolve(res)
	}).catch(err => {
		return Promise.reject(err)
	})
}

export const accessTokenStart = () => {
	return { type: ACCESS_TOKEN_START }
}
export const accessTokenSuccess = (data) => {
	return { type: ACCESS_TOKEN_SUCCESS, data: data }
}
export const accessTokenFailed = () => {
	return { type: ACCESS_TOKEN_FAILED }
}

export const getInboxEmails = ({ email, accessToken = null }) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	dispatch(accessTokenStart())
	return callPost(`/api/emailSettings/getTokenAndEmails`, {
		email, accessToken
	}, token).then(async (res) => {
		dispatch(accessTokenSuccess(res?.data?.token))
		return Promise.resolve(res?.data)
	}).catch(err => {
		accessTokenFailed()
		return Promise.reject(err)
	})
}

export const getEmailsRelatedToUser = () => (dispatch, getState) => {
	const { auth: { token } } = getState()
	dispatch(accessTokenStart())
	return callGet(`/api/emailSettings/getEmailsRelatedToUser`, token).then(async (res) => {
		dispatch(accessTokenSuccess(res?.data?.token))
		return Promise.resolve(res?.data)
	}).catch(err => {
		accessTokenFailed()
		return Promise.reject(err)
	})
}

export const emailAuthStart = () => {
	return { type: AUTH_EMAIL_START }
}
export const emailAuthSuccess = (data) => {
	return { type: AUTH_EMAIL_SUCCESS, data: data }
}
export const emailAuthFailed = () => {
	return { type: AUTH_EMAIL_FAILED }
}

export const googleAuth = ({ cred, userId, email }) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/auth/google`, { cred, userId, email }, token).then(async (res) => {
		return Promise.resolve(res?.data?.authDetails)
	}).catch(err => {
		return Promise.reject(err)
	})
}

export const updateDefaultEmail = (emailId) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/emailSettings/updateDefaultEmail`, { emailId }, token).then(async (res) => {
		return Promise.resolve(res)
	}).catch(err => {
		return Promise.reject(err)
	})
}